// extracted by mini-css-extract-plugin
export var chevron = "_df-4";
export var chevronExpanded = "_df-5";
export var row = "_df-0";
export var rowBody = "_df-6";
export var rowDescription = "_df-7";
export var rowHeader = "_df-1";
export var rowTitle = "_df-2";
export var rowTitleComplete = "_df-3";